package com.xtream.data_kmp.remote

import io.ktor.client.HttpClient

expect fun platformClient(): HttpClient



 fun createApiService(baseUrl: String, username: String, password: String): ApiService {
    return ApiServiceImpl(
        client = platformClient(),
        baseUrl = baseUrl,
        username = username,
        password = password
    )
}

 fun createApiService(baseUrl: String, activationCode: String): ApiService {
    return ApiServiceImpl(
        client = platformClient(),
        baseUrl = baseUrl,
        activationCode = activationCode
    )
}

 fun createApiService(baseUrl: String): ApiService {
    return ApiServiceImpl(
        client = platformClient(),
        baseUrl = baseUrl
    )
}

